import api from "../../config/apiConfig";

export const BOND_ENDPOINTS = {
  getAll: "bond/getAll",
  add: "bond/add",
  edit: "bond/edit",
};

const postWithAuth = async (url: string, data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post(url, data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getAllBonds = async (data: any) =>
  postWithAuth(BOND_ENDPOINTS.getAll, data);

const addBond = async (data: any) => postWithAuth(BOND_ENDPOINTS.add, data);

const editBond = async (data: any) => postWithAuth(BOND_ENDPOINTS.edit, data);

const bondService = { getAllBonds, addBond, editBond };
export default bondService;
